export default "__VITE_ASSET__CNFCZ0S7__"